import useApi, { getCustomError } from 'common/hooks/useApi';
import useThunkDispatch from 'common/hooks/useThunkDispatch';
import useTypedSelector from 'common/hooks/useTypedSelector';
import { isActionCompleteFail } from 'common/services/api/isActionCompleteFail';
import { isActionCompleteSuccess } from 'common/services/api/isActionCompleteSuccess';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import { useEffect } from 'react';
import VacationRentalPresenter from './VacationRentalPresenter';
import { VacationRentalRequest } from './VacationRentalRequest';
import { fetchSubmittedLicenses } from './VacationRentalSlice';

function VacationRentalContainer() {
  const { licenseState } = useTypedSelector((state) => ({
    licenseState: state.licenses,
  }));
  const dispatch = useThunkDispatch();
  const [state, request] = useApi<ActionCompleteResponse>({
    url: '/vrbb',
    method: 'POST',
  });

  useEffect(() => {
    dispatch(
      fetchSubmittedLicenses({
        page: 0,
        items: 10,
      })
    );
  }, [dispatch]);

  const handlePageChange = (page: number) => {
    dispatch(
      fetchSubmittedLicenses({
        page: page,
        items: 10,
      })
    );
  };

  const handleSubmit = async (values: VacationRentalRequest) => {
    await request<VacationRentalRequest>(values);
    handlePageChange(0);
  };

  let errors: string[] | null = null;
  if (isActionCompleteFail(state.data)) {
    errors = getCustomError(state.data).split('\n');
  } else if (Array.isArray(state.data)) {
    errors = state.data.map((d) => d.message);
  } else if (state.error) {
    errors = [state.error];
  }

  return (
    <>
      <VacationRentalPresenter
        onSubmit={handleSubmit}
        saving={state.loading}
        errors={errors}
        success={isActionCompleteSuccess(state.data)}
        data={licenseState.meta.currentPageIds.map(
          (id) => licenseState.entities[id]
        )}
        pagination={{
          totalPages: licenseState.meta.pagination.totalPages,
          totalCount: licenseState.meta.pagination.totalCount,
          currentPage: licenseState.meta.pagination.currentPage,
          itemsPerPage: licenseState.meta.pagination.itemsPerPage,
          onPageChange: handlePageChange,
        }}
        onPageChange={handlePageChange}
      />
    </>
  );
}
export default VacationRentalContainer;
